<template>
  <div class="basket container fluid">
    <div class="basket__nav row">
      <router-link class="basket__nav__back" to="/shoes">
        <img src="@/assets/images/ic_back.svg" />
      </router-link>
      <Logo class="basket__nav__logo" color />
    </div>
    <div class="basket-layout">
      <BasketReassurance />
      <div class="row" style="flex: 1">
        <BasketResume :shoe="myShoe" :user="user" class="col-md-5" />
        <div class="basket__content col-md-7">
          <div class="basket__content__title">
            <h2>Plus que deux étapes !</h2>
            <p>
              Confirmez vos coordonnées de livraison
            </p>
          </div>
          <div class="basket__content__form">
            <BasketForm :user="user" :shoe="myShoe" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import Logo from "@/components/Common/Logo";
import BasketResume from "@/components/Basket/BasketResume";
import BasketReassurance from "@/components/Basket/BasketReassurance";
import BasketForm from "@/components/Basket/BasketForm";
export default {
  name: "Basket",
  components: {
    Logo,
    BasketResume,
    BasketForm,
    BasketReassurance
  },
  computed: {
    ...mapState({
      shoe: state => state.auth.shoe,
      user: state => state.auth.user
    }),
    ...mapGetters({
      getShoeById: "getShoeById"
    }),
    myShoe() {
      return this.getShoeById(this.shoe);
    }
  }
};
</script>

<style lang="scss">
.basket {
  &__nav {
    position: relative;
    justify-content: center;
    align-items: center;
    font-size: 1.6rem;
    padding: 2rem;
    img {
      height: 1.5rem;
      margin-right: 1rem;
    }
    &__back {
      position: absolute;
      left: 2rem;
    }
  }
  &-layout {
    display: flex;
    flex-direction: column;
    min-height: calc(100vh - 6.8rem);
    @media #{$md-and-down} {
      padding: 1rem;
    }
  }
  &__content {
    padding: 1rem;
    @media #{$md-and-up} {
      display: flex;
      flex-direction: column;
      justify-content: center;
    }
    &__title {
      margin-bottom: 2rem;
      text-align: center;
      > h2 {
        font-size: 2.4rem;
        font-weight: bold;
        line-height: 1.5em;
        margin-bottom: 1rem;
        color: get($theme, "primary");
      }
    }
  }
}
</style>
